<div mat-list-item class="mat-typography item" [ngStyle]="{ 'border-color': itinerary.status | itineraryStatusColor }"
  [ngClass]="{
  'warning-yellow': !itinerary.test && itinerary.status !== 'DONE' && getElapsedDays(itinerary)>=1 && !itinerary.assignee,
  'warning-red':  !itinerary.test && itinerary.status !== 'DONE' && ((itinerary.plan === 'smart' && getElapsedDays(itinerary)>=14) || (itinerary.plan === 'premium' && getElapsedDays(itinerary)>=6) || (itinerary.plan === 'top' && getElapsedDays(itinerary)>=3))
  }" fxLayout="row">
  <a fxFlex fxLayout="row" fxLayoutAlign="start center" [routerLink]="isClickable() ? ['.', itinerary.id] : []"
    (click)="onClick()">
    <img class="itinerary-photo" [src]="itinerary.coverImage?.url || '/assets/itinerary-without-image.png'" />
    <div fxLayout="column">
      <h4 mat-line class="itinerary-title">
        {{ itinerary.title }} &mdash; {{ itinerary.destination }}
      </h4>
      <p mat-line class="itinerary-dates">
        <small>{{ itinerary.start?.toDate() | date }} ›
          {{ itinerary.end?.toDate() | date }}
          <span *ngIf="userRole !== 'CUSTOMER'">
            &mdash; {{ itinerary.customerData?.displayName }}</span></small>
      </p>
    </div>
    <span fxFlex></span>
    <div fxLayout="column" class="itinerary-assignee" fxHide.xs>
      <div>
        <small *ngIf="itinerary.test" style="color: #02A5F4">
          <b>TEST</b> &nbsp;
        </small>
        <small *ngIf="itinerary.assignee">{{
          itinerary.assigneeData?.displayName || itinerary.assigneeData?.email
          }}</small>
      </div>
      <div *ngIf="itinerary.createdAt || itinerary.plan">
        <small *ngIf="itinerary.createdAt">
          ordine {{ itinerary.createdAt.toDate() | date:'shortDate'}} &mdash; <b>{{getElapsedDays(itinerary)}}</b>
          giorni fa
        </small>
        <small *ngIf="itinerary.plan" style="min-width: 56px; text-align: center;">
          &mdash; <b>{{(itinerary.plan ? itinerary.plan : "?") | uppercase}}</b>
        </small>
      </div>
    </div>
    <div class="itinerary-status" [fxHide.xs]="true">
      <mat-chip-list>
        <mat-chip [ngStyle]="{
            'background-color': itinerary.status | itineraryStatusColor
          }">{{ itinerary.status | itineraryStatusLabel }}</mat-chip>
      </mat-chip-list>
    </div>
  </a>
  <div class="itinerary-download-url">
    <a *ngIf="itinerary.status === 'IN_REVIEW' || itinerary.status === 'DONE'" mat-icon-button color="primary" href="{{
        userRole === 'CUSTOMER'
          ? itinerary.link.shortUrl
          : itinerary.link.longUrl
      }}" target="_blank">
      <mat-icon>file_download</mat-icon>
    </a>
  </div>
  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="" *ngIf="userRole === 'ADMIN'">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item *ngIf="itinerary.archived == false" (click)="onArchiveClick()">
      <mat-icon>archive</mat-icon>
      <span>Archivia</span>
    </button>
    <button mat-menu-item *ngIf="itinerary.archived == true" (click)="onUnarchiveClick()">
      <mat-icon>move_to_inbox</mat-icon>
      <span>Sposta in "In Arrivo"</span>
    </button>
    <button mat-menu-item (click)="onDeleteClick()">
      <mat-icon>delete</mat-icon>
      <span>Elimina</span>
    </button>
  </mat-menu>
</div>